/**
 * Spatial audio configuration
 * Different sound types can have different distance settings
 */
const SPATIAL_AUDIO_CONFIG = {
  // Default settings
  default: {
    maxDistance: 1200,
    refDistance: 100,
    rolloffFactor: 1.5,
    distanceModel: 'exponential'
  },

  // Weapon sounds - louder, travel farther
  weapons: {
    maxDistance: 1500,
    refDistance: 150,
    rolloffFactor: 1.2,
    distanceModel: 'exponential'
  },

  // Footsteps - quieter, shorter range
  footsteps: {
    maxDistance: 400,
    refDistance: 50,
    rolloffFactor: 2.0,
    distanceModel: 'exponential'
  },

  // Abilities - medium range
  abilities: {
    maxDistance: 1000,
    refDistance: 100,
    rolloffFactor: 1.5,
    distanceModel: 'exponential'
  },

  // Damage/hit sounds - short range
  damage: {
    maxDistance: 600,
    refDistance: 80,
    rolloffFactor: 1.8,
    distanceModel: 'exponential'
  },

  // Pickups - short range
  pickups: {
    maxDistance: 400,
    refDistance: 60,
    rolloffFactor: 2.0,
    distanceModel: 'exponential'
  }
};

export { SPATIAL_AUDIO_CONFIG };
